export const APP_STARTED = 'APP_STARTED';
export const appStarted = () => {
  return {
    type: APP_STARTED
  };
};
